import React from 'react'
import { Container } from 'react-bootstrap'
import { QueryListProvider } from '../../../../component/solution/QueryTableList/QueryListContext';
import { QueryTableList } from '../../../../component/solution/QueryTableList/QueryTableList';
import { formatDateFull } from '../../../../component/solution/utils/AppUtil';


interface IVarianceItem {
    id: string,
    created: string,
    updated: string, 
    item_code: string,
    barcode: string,
    item_name: string,
    item_group: string,
    qty_good_whs: number,                    
    qty_damaged_client_whs: number,
    qty_damaged_m24l_whs: number,
    qty_on_hand_erp: number,
    qty_committed_erp: number,
    qty_damaged_erp: number,
    qty_damaged2_erp: number,               
    qty_returns_intransit_erp: number,    
    qty_suspense_erp: number,
    qty_investigate_erp: number,
    qty_lost_erp: number,
    qty_found_erp: number,
    qty_diff: number,
    qty_diff1: number,
    qty_diff2: number,
    qty_diff3: number,
    qty_expected_po: number
}


export const Variance: React.FC = () => {

  return (
     <Container fluid className="p-0">
             <QueryListProvider>
                <QueryTableList
                    listTitle={"Variance Report"}
                    recordTitle={"Variance Report"}
                    tableName={""}
                    editTableName={""}
                    hasIntegrationStatusLegend={false} 
                    errorCategoryName={''}
                    editHasCompoundKey={false}   
                    showFailedTransactionsTable={false}
                    query={{
                        appCode: null,
                        selectCode: null,
                        tableName: "sa_stock_variance",
                        where: "",
                        orderBy: '',
                        pageNum: 0,
                        pageSize: 100,
                        params: {},
                    }} 
                    orderColumns={[
                        { name: "item_code", type: "STRING", sortable: true, searchable: true },
                        { name: "barcode", type: "STRING", sortable: true, searchable: true },
                        { name: "item_name", type: "STRING", sortable: true, searchable: true },
                        { name: "item_group", type: "STRING", sortable: true, searchable: true },
                        { name: "qty_good_whs", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_damaged_client_whs", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_damaged_m24l_whs", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_on_hand_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_committed_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_damaged_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_returns_intransit_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_suspense_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_investigate_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_lost_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_found_erp", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_diff", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_diff1", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_diff2", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_diff3", type: "NUMBER", sortable: true, searchable: true },
                        { name: "qty_expected_po", type: "NUMBER", sortable: true, searchable: true },
                    ]}
                    reportOptions={{ 
                            reportQuery: {
                            appCode: null,
                            selectCode: null,
                            tableName: "sa_stock_variance", 
                            where: "",
                            orderBy: "",
                            pageNum: 0,
                            pageSize: 0,
                            params: {},
                        },
                        templateName: "apps/ares/variance_report.xlsx", 
                        reportName: "stock_variance_report.xlsx",
                        reportData: null
                    }}   
                    renderRowData={(row) => {
                                            
                        const tdStyle: React.CSSProperties = { whiteSpace: 'nowrap', border: '1px solid #deebed',  padding: '4px 8px', fontSize: '0.75rem' };
                  
                        return (
                            <>
                                <td style={tdStyle} title={row.item_code}>{row.item_code}</td>
                                <td style={tdStyle} title={row.barcode}>{row.barcode}</td>
                                <td style={tdStyle} title={row.item_name}>{row.item_name}</td>
                                <td style={tdStyle} title={row.item_group}>{row.item_group}</td>
                                <td style={tdStyle} title={row.qty_good_whs}>{row.qty_good_whs}</td>
                                <td style={tdStyle} title={row.qty_damaged_client_whs}>{row.qty_damaged_client_whs}</td>
                                <td style={tdStyle} title={row.qty_damaged_m24l_whs}>{row.qty_damaged_m24l_whs}</td>
                                <td style={tdStyle} title={row.qty_on_hand_erp}>{row.qty_on_hand_erp}</td>
                                <td style={tdStyle} title={row.qty_committed_erp}>{row.qty_committed_erp}</td>
                                <td style={tdStyle} title={row.qty_damaged_erp}>{row.qty_damaged_erp}</td>
                                <td style={tdStyle} title={row.qty_returns_intransit_erp}>{row.qty_returns_intransit_erp}</td>
                                <td style={tdStyle} title={row.qty_suspense_erp}>{row.qty_suspense_erp}</td>
                                <td style={tdStyle} title={row.qty_investigate_erp}>{row.qty_investigate_erp}</td>
                                <td style={tdStyle} title={row.qty_lost_erp}>{row.qty_lost_erp}</td>
                                <td style={tdStyle} title={row.qty_found_erp}>{row.qty_found_erp}</td>
                                <td style={tdStyle} title={row.qty_diff}>{row.qty_diff}</td>
                                <td style={tdStyle} title={row.qty_diff1}>{row.qty_diff1}</td>
                                <td style={tdStyle} title={row.qty_diff2}>{row.qty_diff2}</td>
                                <td style={tdStyle} title={row.qty_diff3}>{row.qty_diff3}</td>
                                <td style={tdStyle} title={row.qty_expected_po}>{row.qty_expected_po}</td>
                            </>    
                        );
                    }}   
                    renderActions={(row) => {
                            return (
                              <td className="sa-record-control" style={{ border: '1px solid #deebed', height: '45px', fontSize: '0.55rem', padding: '0 5px'}}>
                               
                             </td>
                            );
                    }}                      
                />
            </QueryListProvider>
        </Container>
  )
}
